"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuseDevice = void 0;
const bluetooth_le_1 = require("@capacitor-community/bluetooth-le");
const events_1 = require("events");
const muse_parsers_1 = require("../lib/muse-parsers");
const muse_utils_1 = require("../lib/muse-utils");
const muse_1 = require("../pipes/muse");
const c = __importStar(require("../lib/constants"));
const rxjs_1 = require("rxjs");
class MuseDevice extends events_1.EventEmitter {
    constructor() {
        super();
        this.active = new rxjs_1.BehaviorSubject(false);
        this.eeg = muse_1.eeg(this);
        this.ppg = muse_1.ppg(this);
        this.accel = muse_1.accel(this);
        this.gyro = muse_1.gyro(this);
        this.telemetry = muse_1.telemetry(this);
    }
    async startStreams(device) {
        await muse_utils_1.sendCommand(device.deviceId, 'd');
        this.active.next(true);
        // Setup Notifications
        bluetooth_le_1.BleClient.startNotifications(device.deviceId, muse_utils_1.MUSE, c.MUSE_GATT_ATTR_STREAM_TOGGLE, () => {
            console.log('Control');
        });
        bluetooth_le_1.BleClient.startNotifications(device.deviceId, muse_utils_1.MUSE, c.MUSE_GATT_ATTR_TELEMETRY, (t) => {
            this.emit('tele', t);
        });
        // BioMetrics
        const eeg = c.MUSE_CHANNEL_NAMES.slice(0, 4);
        Array.from(eeg).map((_, i) => {
            bluetooth_le_1.BleClient.startNotifications(device.deviceId, muse_utils_1.MUSE, c.MUSE_EEG_CHARACTERISTICS[i], (v) => {
                this.emit('eeg', muse_parsers_1.parseEEG(i, v));
            });
        });
        const ppg = c.MUSE_PPG_CHANNELS;
        Array.from(ppg).map((_, i) => {
            bluetooth_le_1.BleClient.startNotifications(device.deviceId, muse_utils_1.MUSE, c.MUSE_PPG_CHARACTERISTICS[i], (v) => {
                this.emit('ppg', muse_parsers_1.parsePPG(i, v));
            });
        });
        bluetooth_le_1.BleClient.startNotifications(device.deviceId, muse_utils_1.MUSE, c.MUSE_GATT_ATTR_ACCELEROMETER, (v) => {
            // TODO: not the best way to do it
            muse_parsers_1.parseAccel(v).map((s) => this.emit('accel', s));
        });
        bluetooth_le_1.BleClient.startNotifications(device.deviceId, muse_utils_1.MUSE, c.MUSE_GATT_ATTR_GYRO, (v) => {
            // TODO: not the best way to do it
            muse_parsers_1.parseGyro(v).map((s) => this.emit('gyro', s));
        });
    }
    async stopStreams(device) {
        await muse_utils_1.sendCommand(device.deviceId, 'h');
        this.active.next(false);
    }
}
exports.MuseDevice = MuseDevice;
//# sourceMappingURL=muse.js.map